<!-- <div style="display: inline-block" 
    aria-live="polite" 
    aria-atomic="true" 
    *ngIf="errorList.length > 0">
    <div class="sis-header-icon" 
        style="display:inline-block; cursor:pointer;padding-top:2px;padding-right:20px;"
        (click)="errorCircleClick(); $event.stopPropagation();" 
        tabindex="0" 
        (keydown)="$event.key == 'Enter' || $event.key == ' ' ? errorCircleClick() : null"
        aria-label="errors button. Press to view errors.">
        <div style="margin-top:2px;">
            <img style="position:absolute" src="./assets/images/Error circle.png" class="sis-header-icon" />
            <span [ngStyle]="{'bottom': insideFlex ? '' : '27px'}" style="position:absolute; font:bold 18pt 'Segoe UI'; color:white;width:38px;text-align:center;cursor:pointer;">{{errorList.length}}</span>
        </div>
        <div style="position: relative; top: 39px; text-align:center;">
            <span>Errors</span> 
        </div>
    </div>    
</div> -->
<div *ngIf="errorList.length > 0"
    aria-live="polite"
    aria-atomic="true"
    style="cursor:pointer;"
    (click)="errorCircleClick(); $event.stopPropagation();" 
    (keydown)="$event.key == 'Enter' || $event.key == ' ' ? errorCircleClick() : null"
    aria-label="errors button. Press to view errors.">
    <button mat-button
        [disableRipple]="true"
        color="warn"
        class="errorPrompt">
        <span class="errorNumber">{{errorList.length}}</span>
        <span class="errorText" translate>Errors</span>
    </button>
</div>
